"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRandomValues = void 0;
var hasGlobalWebCrypto_1 = require("../hasGlobalWebCrypto.js");
function _getRandomValues(buff) {
    for (var i = 0; i < buff.length; i++) {
        buff[i] = (Math.random() * 256) >>> 0;
    }
    return buff;
}
/** [MDN Reference](https://developer.mozilla.org/docs/Web/API/Crypto/getRandomValues) */
exports.getRandomValues = hasGlobalWebCrypto_1.hasGlobalWebCrypto ? globalThis.crypto.getRandomValues.bind(globalThis.crypto) : _getRandomValues;
